import React from "react";
import DataTable from "../../../components/DataTable";
const dataJson = [
  {
    id: "4347348",
    date: "03/03/2022",
    receiveAddress: "ncxjfXdfdfjdYRTL",
    amount: "$457",
    senderAddress: "Xfdhfsjfserf",
    status: "Received",
  },
  {
    id: "sf7df8sf5",
    date: "15/03/2022",
    receiveAddress: "feiriuslkf",
    amount: "$787",
    senderAddress: "fseurrfusf",
    status: "Received",
  },
  {
    id: "f7sf8s",
    date: "03/03/2022",
    receiveAddress: "ncxjfXdfdfjdYRTL",
    amount: "$457",
    senderAddress: "Xfdhfsjfserf",
    status: "Received",
  },
];

const columns = [
  { id: "id", label: "ID #", minWidth: 20 },
  { id: "date", label: "Date", minWidth: 100 },
  {
    id: "receiveAddress",
    label: "Receiver Address (TRX)",
    minWidth: 80,
  },
  {
    id: "senderAddress",
    label: "Sender Address (TRX)",
    minWidth: 80,
  },
  {
    id: "status",
    label: "Status",
    minWidth: 80,
  },
];

function createData(id, date, receiveAddress, senderAddress, status) {
  return {
    id,
    date,
    receiveAddress,
    senderAddress,
    status,
  };
}

const rows = dataJson.map((d) =>
  createData(d.id, d.date, d.receiveAddress, d.senderAddress, d.status)
);

const FundsTxnHistoryTable = () => {
  return (
    <DataTable
      columns={columns}
      rows={rows}
      perPageShow={6}
      tableHeight={440}
      className="common_table"
    />
  );
};

export default FundsTxnHistoryTable;
